export { Avatar } from './Avatar';
export type { AvatarProps, AvatarSize } from './Avatar';
